var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Header'),_c('router-view'),_c('MobileBar',{on:{"active":_vm.popupUser}}),_c('PopupUser',{attrs:{"active":_vm.active},on:{"active":_vm.popupUser}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }